import type { InputHTMLAttributes } from "react";

interface PrefixInputProps extends InputHTMLAttributes<HTMLInputElement> {
  prefix: string;
  error?: boolean;
}

export default function PrefixInput({
  prefix,
  error,
  className = "",
  ...rest
}: PrefixInputProps) {
  return (
    <div className="flex w-full">
      <span className="inline-flex h-[42px] shrink-0 items-center rounded-l-lg border border-r-0 border-slate-300 bg-page px-3.5 text-sm font-medium text-ink-secondary">
        {prefix}
      </span>
      <input
        className={`h-[42px] w-full rounded-r-lg border bg-white px-3.5 text-sm text-ink placeholder:text-ink-muted focus:outline-none focus:ring-2 ${
          error
            ? "border-danger focus:ring-danger/30"
            : "border-slate-300 focus:border-primary-500 focus:ring-primary-500/30"
        } ${className}`}
        {...rest}
      />
    </div>
  );
}